import { render } from "./view_business_info.vue?vue&type=template&id=669034fe"
import script from "./view_business_info.vue?vue&type=script&lang=js"
export * from "./view_business_info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__